import Footer from "./footer";
import Header from "./Header";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useRef, useState } from "react";
import { AddToCartURL, image_url, Post, ProductDetailURL, ProductsURL } from "../utils/api";
import { useParams } from "react-router-dom";
import Button from "../component/Button";
import {wrapComponent} from 'react-snackbar-alert';
import { useSelector } from "react-redux";
import { useNavigate,Link } from 'react-router-dom';
import CartModal from "../component/cartModal";

const Shop = ({createSnackbar}) => {
  const [item,setitem] = useState({});
  const [faqs,setfaqs] = useState([]);
  const [List,setList] = useState([]);
  const params = useParams();
  const {cartItems,userinfo} = useSelector((state)=>state);
  const navigate = useNavigate();

  useEffect(()=>{
      window.scrollTo(0, 0)
      fetchItemList();
      fetchProductList()
  },[params.id]);


  const showSnack = (msg='',type='error') =>{
    createSnackbar({
      message: msg,
      theme: type,
    });
  }

  const fetchItemList = () =>{
    global.Loader(true)
    let config = {
        body:{product_id:params?.id},
        url:ProductDetailURL,
    }
    Post(config).then((res)=>{
        global.Loader(false)
        if(res.status == true) {
          let varient = res?.products?.item_variations;
          setfaqs(res?.faq);
          if(varient) {
            varient = varient[0];
            let item = {...res?.products,
              product_weight : varient.product_weight,
              varient_id : varient.id,
            }
            setitem(item)
          } else {
            setitem(res?.products)
          }
          
        }
    }).catch((err)=>{
      global.Loader(false)
      console.log(err?.response?.data);
    })
  }

  const [refres,setrefres] = useState(false);

  const [activeIndex,setactiveIndex] = useState(0);
  const slider = useRef()
  var settings = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide:true,
    vertical: true,
    verticalSwiping: true,
  };
  
  var settings1 = {
    dots: false,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 3.8,
    // slidesToScroll: 4,
    swipeToSlide:true,
    vertical: true,
    verticalSwiping: true,
  };
  
  var settings3 = {
    dots: true,
    margin:50,
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 3,
  };


  const changeItem = (type,total=10) =>{
      let index = (type == '+') ? activeIndex + 1 : activeIndex - 1;
      slider?.current?.slickGoTo(index);
      setactiveIndex(index);
  }

  const getSliderItem = (item,min) =>{
    if(item?.length  > min) {
      return item;
    } else {
      return item;
    }
  }



  const changeQnty = (qnty) =>{
    let items = {...item};
    items['qnty'] = qnty;
    setitem(items);
}

  const selectVarient = ({id,product_weight}) =>{
    if(id) {
      let items = {...item};
      items.product_weight = product_weight;
      items.varient_id = id;
      setitem(items);
    } else {
      let items = {...item};
      items.product_weight = null;
      items.varient_id = null;
      setitem(items);
    }
  }


  const addToCart = ({qnty=1,id,varient_id}) =>{
    if(userinfo?.token) {
    if(varient_id) {
        global.Loader(true)
        let config = {
            body:{
                product_id:id,
                variant_id:varient_id,
                quantity:qnty,
            },
            url:AddToCartURL,
        }
        Post(config).then((res)=>{
            global.Loader(false)
            if(res.status == true) {
              setrefres(!refres)
              let index = cartItems?.findIndex((v)=>v.product_id == id);
                if(index == -1) {
                    global.dispatch({
                        type:'CARTITEMS',
                        payload: [...cartItems,{product_id:id}]
                    })
                }
                showSnack(res?.msg,'success')
            }
        }).catch((err)=>{
            global.Loader(false)
            console.log(err?.response?.data);
        })
    } else {
        showSnack('Please Select Varient')
    }
  } else {
    showSnack('Please Login')
    navigate('/login')
}
  }

const fetchProductList = () =>{
    global.Loader(true)
    
    let config = {
        body:{},
        url:ProductsURL,
    }
    
    Post(config).then((res)=>{
        global.Loader(false)
        if(res.status == true) {
          let data = res?.products;
          data = data?.filter((v)=>(v.id != params?.id));
          setList(data)
        }
    }).catch((err)=>{
        global.Loader(false)
        console.log(err?.response?.data);
    })
}

const truncate = (value,i=20) =>{
  if(value) {
    if(value?.length > i) {
      return `${value.substr(0,i)}...`;
    } else {
      return value;
    }
      
  } else {
      return '';
  }
}

const getRating= (value) =>{
  let Array =[];
  let lasti = 1;
  for(let i = 1; i < 6; i++) {
      if(value >= i) {
          Array.push(1);
      } else {
          Array.push(0);
      }
  }
  return Array;
}
  return (
  <div>
    <Header  cartClick={()=>{
        setrefres(!refres)
      }}  />
    <div className="mizuki">
      <span className="ipsum"><i className="fa-solid fa-left-long"></i></span>
      <h1>Active Men</h1>
      <span className="ipsum1"><i className="fa-sharp fa-solid fa-xmark"></i></span>
    </div>

    <div className="active1">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <section className="slider0">
                <div className="slider__flex">
                  
                  <div className="slider__col">
                    <div onClick={()=>changeItem('-')} className="slider__prev"><i className="fa-solid fa-chevron-up"></i></div>
                    <div className="slider__thumbs">
                      <div className="swiper-container">
                        <div className="swiper-wrapper">
                          <Slider {...settings1} >
                            {getSliderItem(item?.product_images,4)?.map((value,index)=>(
                              <div onClick={()=>{
                                slider?.current?.slickGoTo(index);
                                setactiveIndex(index);
                              }} className="swiper-slide philips">
                                <div className="slider__image yoga1" style={(activeIndex==0)?{'filter':'grayscale(0%)',opacity:1,marginBottom:20}:{marginBottom:20}}>
                                  <img src={`${image_url}${value?.image}`} alt="" />
                                </div>
                              </div>
                            ))}
                          </Slider>
                        </div>
                      </div>
                    </div>
                   <div onClick={()=>changeItem('+')} className="slider__next"><i className="fa-solid fa-chevron-down"></i></div>  
                  </div>
                  
                  <div className="slider__images" style={{padding : "0px 2%"}}>
                    <div className="swiper-container">
                      <div className="swiper-wrapper">
                      <Slider ref={slider} {...settings} initialSlide={activeIndex}>
                        {item?.product_images?.map((value,index)=>(
                          <div className="swiper-slide" key={`slider_${index}`}>
                            <div className="slider__image yoga"><img src={`${image_url}${value?.image}`} alt="" /></div>
                          </div>
                        ))}
                        </Slider>
                      </div>
                    </div>
                    <div className="sportive_man">
                      <div className="vector_man">
                        <img src="/images/Vector.png" alt=""/>
                      </div>
                      <div className="sportive_man1">
                        <img src="/images/sportive-man.png" alt=""/>
                      </div>
                      <div className="vector_man1">
                        <img src="/images/Vector (1).png" alt=""/>
                      </div>
                    </div>
                    <div className="across">
                      <div className="wojtek">
                      <select onChange={({target})=>{
                          changeQnty(target?.value);
                        }} value={(item?.qnty)?item?.qnty : 1} style={{
                            width: "69px",
                            borderRadius: "15px",
                            fontSize: "16px",
                            paddingLeft: "10px",
                            paddingRight: "10px",
                            backgroundColor: "white",
                            border: "0px",
                            height: '36px',
                            marginTop: '7px',
                            marginLeft: '11px',
                        }}>
                            <option><span>1 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>2 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>3 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>4 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>5 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>6 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>7 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>8 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>9 <i className="fa-solid fa-angle-down"></i></span></option>
                            <option><span>10 <i className="fa-solid fa-angle-down"></i></span></option>
                        </select>
                        {/* <p>2 <i className="fa-solid fa-chevron-down"></i></p> */}
                        <Button onClick={()=>{addToCart(item)}} style={{width:'100%',fontSize:17}} backgroundColor={'#219653'} title={`Add to cart (₹${(item?.price * parseInt((item?.qnty)?item?.qnty:1))})`} />
                        {/* <button >Add to cart <span> ₹{item?.price} </span><i className="fa-solid fa-chevron-right" style={{'marginRight':'5px'}}></i></button> */}
                      </div>
                      <p>Free 7-10 days delivery across India</p>
                      
                    </div>
                  </div>
                </div>

              </section>
          </div>
          <div className="col-md-6">
            <div className="have">
              <div className="shoplink">
                <ul>
                  <li onClick={()=>{
                    navigate('/home')
                  }}>Home</li> <i className="fa-solid fa-chevron-right" style={{'marginRight':'5px'}}></i>
                  <li onClick={()=>{
                    navigate('/shoppage')
                  }}>Shop</li> <i className="fa-solid fa-chevron-right" style={{'marginRight':'5px'}}></i>
                  <li><a href="#">{item?.title}</a></li>
                </ul>
                <div className="reviews">
                  <h4>{truncate(item?.title,80)}</h4>
                  <div className="icon-star" style={{marginTop:'10px'}}>
                  {getRating(item.avg_rating)?.map((v,i)=>(
                      (v==1)?<i className="fa-solid fa-star"></i>:<i className="fa-regular fa-star"></i>
                  ))}
                    {/* <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-solid fa-star"></i>
                    <i className="fa-regular fa-star"></i> */}
                    <p> <span> {item.avg_rating} </span>| {item.no_of_review} Reviews</p>
                  </div>
                </div>
                <div >
                  <select className="selector">
                    <option onClick={
                        ()=>{
                          selectVarient({})
                        }
                      }><p>Select Varient <i className="fa-solid fa-chevron-down"></i></p></option>
                    {item?.item_variations?.map((v,i)=>(
                      <option selected={(v.id == item?.varient_id)} onClick={
                        ()=>{
                          selectVarient(v)
                        }
                      }>
                        <p>{v?.product_weight} <i className="fa-solid fa-chevron-down"></i></p>
                      </option>
                    ))}
                  </select>
                </div>
                <div className="artboard1">
                  <img src="/images/Artboard 1@4x.png" alt=""/>
                </div>
                <div className="been">
                  <p dangerouslySetInnerHTML={{__html: item?.description}}></p>
                  {/* <a href="#">Read More</a> */}
                </div>
                <div className="artboard">
                  <img src="/images/Artboard 1@4x.png" alt=""/>
                </div>
                <div className="cravings">
                  {(item?.product_benefit?.map((value,index)=>(
                    <p><img src={`${image_url}${value?.icon}`} style={{height:'30px',width:'30px',marginRight:'10px'}} /> {value?.point}</p>
                  )))}
                </div>
              </div>
            </div>
            <div className="diet">
              <table>
                <tr>
                  <th>Diet</th>
                  <td></td>
                  <td className="per_day1">{item?.diet}</td>
                </tr>
                <tr>
                  <th>Age Range</th>
                  <td></td>
                  <td className="per_day1">{item?.age_range}</td>
                </tr>
                <tr>
                  <th>Suitable for</th>
                  <td></td>
                  <td className="per_day1">{item?.gender}</td>
                </tr>
                </table>
                <div className="line"></div>
                <table>
                <tr>
                  <th>Dosage</th>
                  <td></td>
                  <td className="per_day">{item?.dosage} Tablet per day</td>
                </tr>
                <tr>
                  <th>Country of origin</th>
                  <td></td>
                  <td className="per_day">{item?.country_of_orign}</td>
                </tr>
                <tr>
                  <th>Manufacturer</th>
                  <td></td>
                  <td className="per_day">{item?.manufacturer}</td>
                </tr>
                <tr>
                  <th>Marketeer</th>
                  <td></td>
                  <td className="per_day">{item?.marketer}</td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

        <div className="Product Details">
          <h1>Product Details</h1>
          <ul className="nav nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">Star Ingredients & Benefits</button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile" type="button" role="tab" aria-controls="profile" aria-selected="false">Nutritional Information</button>
              </li>
              {/* <li className="nav-item" role="presentation">
                <button className="nav-link" id="contact-tab" data-bs-toggle="tab" data-bs-target="#contact" type="button" role="tab" aria-controls="contact" aria-selected="false">FAQs</button>
              </li> */}
          </ul>
          <div className="tation">
            <div className="tab-content" id="myTabContent">
              <div className="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
                <div className="accordion" id="accordionExample">
                  {item?.ingridents?.map((v,i)=>(
                    <div className="accordion-item">
                    <h2 className="accordion-header" id="headingTwo">
                      <button className="accordion-button collapsed collapsed1" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseTwo${i}`} aria-expanded="false" aria-controls={`collapseTwo${i}`}>
                        {v.title}
                      </button>
                    </h2>
                    <div id={`collapseTwo${i}`} className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <div className="Ginger">
                        <img style={{
                                marginTop:'50px',
                                height: '100px',
                                width: '100px',
                                marginLeft: '-8px',
                            }} src={`${image_url}${v?.image}`} alt=""/>
                              <div className="dolor">
                                <p>{v.description}</p>
                              </div>
                            </div>
                      </div>
                    </div>
                  </div>
                  ))}
                  
                </div>
              </div>
              <div className="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                <div className="accordion" id="accordionExample">
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="headingOne">
                        <p style={{padding:'20px'}} dangerouslySetInnerHTML={{__html: item?.nutritional_information}}></p>
                    </h2>
                    {/* <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                      <div className="accordion-body">
                        <strong>This is the first item's accordion body.</strong> It is shown by default, until the collapse plugin adds the appropriate classes that we use to style each element. These classes control the overall appearance, as well as the showing and hiding via CSS transitions. You can modify any of this with custom CSS or overriding our default variables. It's also worth noting that just about any HTML can go within the <code>.accordion-body</code>, though the transition does limit overflow.
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                <div className="accordion" id="accordionExample">
                  {faqs?.map((value,index)=>(
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapseThree${index}`} aria-expanded="false" aria-controls={`collapseThree${index}`}>
                          {value.title}
                        </button>
                      </h2>
                      <div id={`collapseThree${index}`} className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                        {value?.description}
                        </div>
                      </div>
                    </div>
                  ))}
                  </div>
              </div>
            </div>
          </div>
        </div>

      <div className="custome">
        <h2 className="text-center">Customer Reviews</h2>
        <div className="gress">
          <div className="icon-star icon_star_out">
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-solid fa-star"></i>
            <i className="fa-regular fa-star"></i>
            <h4> 4.8 out of 5 </h4>
          </div>
          <div className="progress-bar">
            <p>5 star  <span>80%</span></p>
            <div data-progress="80"></div>
            <p>4 star <span>20%</span></p>
            <div data-progress="20"></div>
            <p>3 star <span>0%</span></p>
            <div data-progress="0"></div>
            <p>2 star <span>0%</span></p>
            <div data-progress="0"></div>
            <p>1 star <span>0%</span></p>
            <div data-progress="0"></div>
          </div>
        </div>
      </div>

      

        <div className="akshay">
          <div className="yaana">
            <div className="adipi">
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-regular fa-star"></i>
                <span> | <span></span> Akshay </span>
                <p>Reviewed on 2 July 2021</p>
            </div>
            <div className="grape">
                <p>I brought this multivitamin and already using it. in this we get all the necessary vitamin and minerals it also has amino acids with added special ingredients like ginseng , boswellia , grape seed, turmeric , brahmi, spirulina and any more. I brought this multivita... </p>
                <a href="#">Read less</a>
            </div>
          </div>
          <div className="yaana1">
            <div className="adipi">
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-regular fa-star"></i>
                <span> | <span></span> Akshay </span>
                <p>Reviewed on 2 July 2021</p>
            </div>
            <div className="grape">
                <p>I brought this multivitamin and already using it. in this we get all the necessary vitamin and minerals it also has amino acids with added special ingredients.</p>
                <a href="#">Read More</a>
            </div>
          </div>
          <div className="yaana">
            <div className="adipi">
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-solid fa-star"></i>
                <i className="fa-regular fa-star"></i>
                <span> | <span></span> Akshay </span>
                <p>Reviewed on 2 July 2021</p>
            </div>
            <div className="grape">
                <p>I brought this multivitamin and already using it. in this we get all the necessary vitamin and minerals it also has amino acids with added special ingredients like ginseng , boswellia , grape seed, turmeric , brahmi, spirulina and any more. I brought this multivita... </p>
                <a href="#">Read less</a><br/>
                <span className="more_reviews"><a href="#">View more reviews</a></span>
                <span className="more_reviews1"><a href="#">View more</a></span>
            </div>
          </div>
        </div>        
       
       {(List?.length > 0)&&
        <div>
            <div className="custome">
              <h2 className="text-center">You may also like</h2> 
          </div>
          
              <div className="slider pro" >

              <Slider {...settings3} slidesToShow={(List?.length > 6)?6:List?.length}>
                {List?.map((v,i)=>(
                  <div onClick={()=>{
                    navigate(`/shop/${v.id}`)
                  }} style={{width: "60% !important"}}>
                    <div className="item" style={{marginRight : '10%'}}>
                      {/* <img src="/images/latte-mix.png" alt=""/> */}
                      <img style={{
                          height: '165px',
                          width: '194px',
                          margin: 'auto',
                      }} src={`${image_url}${v?.image}`} alt="" />
                      {/* bug */}
                      <h5 className="text-center">{truncate(v.title,40)}</h5>
                      {/* <p style={{fontSize:'10px !import'}} dangerouslySetInnerHTML={{__html: v?.description}}></p> */}
                      <h2 className="text-center">₹{v.price}</h2>
                    </div>
                  </div>
                ))}
              </Slider>
              </div>
          </div>
          }
          <CartModal refres={refres} show={true} />
        <Footer />
    </div>
  );
}

export default wrapComponent(Shop);